export const swiperConfig = {
  // Swiper 4 Documentation https://github.com/nolimits4web/Swiper/blob/v4/API.md#accessibility-a11y
  pagination: { // enable pagination to navigate with screen reader
    el: '.swiper-pagination.sr-only',
    clickable: true
  },
  simulateTouch: true,
  grabCursor: true,
  watchSlidesVisibility: true, // enable to show visible slides only for screen reader
  a11y: {
    enable: true,
    // Not supported in Swiper 4
    // this roles are added to swiper container and slides directly
    // containerRoleDescriptionMessage: 'Ringelspiel',
    // itemRoleDescriptionMessage: 'Ansicht',
    prevSlideMessage: 'Vorherige Ansicht',
    nextSlideMessage: 'Nächste Ansicht',
    firstSlideMessage: 'Erste Ansicht',
    lastSlideMessage: 'Letzte Ansicht',
    paginationBulletMessage: 'Zu Ansicht {{index}} wechseln',
    slideRole: 'group',
  },
};